import { ReactNode, VFC } from 'react';
import Tooltip from '@adsk/alloy-react-tooltip';
import Theme from '@adsk/alloy-react-theme';
import { isLate, toLongDate } from '../../helpers/date-helpers';
import { Rfi } from '../../sdk/types/common/rfi';
import { useDueDateTimezone } from '../../hooks/useDueDateTimezone';
import { translate } from '../../helpers';
import { RfiStatus } from '../../sdk';

export type DueDateCellProps = {
  rowData: Pick<Rfi, 'closedAt' | 'dueDate' | 'createdAt' | 'status'>;
};

const TOOLTIP_STYLE = { borderRadius: '4px' };

export const DueDateCell: VFC<DueDateCellProps> = ({ rowData }) => {
  const { dueDate, createdAt, status } = rowData;
  const { dueDateTimeZone } = useDueDateTimezone(createdAt);

  const isClosed = status === RfiStatus.Closed;
  const tooltipContent: ReactNode = dueDateTimeZone ? translate('tooltips.dueDate') : null;

  return dueDate ? (
    <Tooltip content={tooltipContent} placement={Tooltip.PLACEMENTS.TOP} style={TOOLTIP_STYLE}>
      <span
        css={[
          Theme.typography.bodyMedium,
          {
            ...(!isClosed &&
              isLate(dueDate) && {
                color: Theme.colors.red700,
              }),
            whiteSpace: 'nowrap',
          },
        ]}
      >
        {toLongDate(dueDate, dueDateTimeZone || 'UTC')}
      </span>
    </Tooltip>
  ) : (
    <span>-</span>
  );
};
